import React from "react";

const PIECES = {
  wK: "♔",
  wQ: "♕",
  wR: "♖",
  wB: "♗",
  wN: "♘",
  wP: "♙",
  bK: "♚",
  bQ: "♛",
  bR: "♜",
  bB: "♝",
  bN: "♞",
  bP: "♟",
};

export default function ChessPiece({
  piece,
  pieceSet = "modern",
}) {
  if (!piece) {
    return null;
  }

  return (
    <span
      className={[
        "chess-piece",
        `chess-piece--${pieceSet}`,
        piece[0] === "w"
          ? "chess-piece--white"
          : "chess-piece--black",
      ].join(" ")}
      aria-hidden="true"
    >
      {PIECES[piece]}
    </span>
  );
}
